<div class="main-wrapper">
    <vwui-header>
        {{ 'PAGE_PROJECT_DETAILS.title' | translate }} {{ project.name }}
        <div class="button-group" right>
            <app-project-status class="header-project-status" [project]="project"></app-project-status>
        </div>
        <div class="project-details__header-extra">{{ project.company }}, {{ project.owner?.name }}</div>
    </vwui-header>
    @if (loadingSpinnerService.isSpinnerVisible()) {
        <vwui-spinner></vwui-spinner>
    } @else {
        <div class="grid">
            <div class="grid__row">
                <div class="grid__col grid__col--5">
                    <div class="processing-thumbnail-spinner" [class.processing-thumbnail-spinner--show]="isProcessingThumbnail">
                        <svg viewBox="0 0 64 64">
                            <circle r="26" transform="translate(32,32)"></circle>
                        </svg>
                        {{ 'PAGE_PROJECT_DETAILS.processing_thumbnail' | translate }}
                    </div>
                    <vwui-form-group>
                        <vwui-image-input class="large" [(ngModel)]="imageBase64" [disabled]="true"></vwui-image-input>
                    </vwui-form-group>
                    <vwui-card>
                        <vwui-card-body>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.address' | translate }}</div>
                                <div class="grid__col grid__col--4 project-details__value">{{ project.address }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.city' | translate }}</div>
                                <div class="grid__col grid__col--4 project-details__value">{{ project.city }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.country' | translate }}</div>
                                <div class="grid__col grid__col--4 project-details__value">{{ project.country | countryName }}</div>
                            </div>
                        </vwui-card-body>
                    </vwui-card>
                    <vwui-card class="project-details-description">
                        <vwui-card-body>
                            <div class="grid__row">
                                <div class="grid__col project-details-description__content">
                                    {{ project.description }}
                                </div>
                            </div>
                        </vwui-card-body>
                    </vwui-card>
                </div>

                <div class="grid__col grid__col--7 project-details__info">
                    <vwui-card>
                        <vwui-card-header>{{ 'PAGE_PROJECT_DETAILS.title_project_info' | translate }}</vwui-card-header>
                        <vwui-card-body>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.units' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">{{ project.projectInfo?.numberOfUnits }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.costs' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">&euro; {{ project.projectInfo?.constructionCostsAsText }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.space' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">{{ project.projectInfo?.commercialSpace }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.bvo' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">{{ project.projectInfo?.bvo }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.work_type' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">{{ workTypes }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.function' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">{{ buildingClassifications }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.sub_function' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">{{ buildingSubClassifications }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.height_above' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">{{ getAnswerValue('project_info.height_above') }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--5 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.height_under' | translate }}</div>
                                <div class="grid__col grid__col--7 project-details__value">{{ getAnswerValue('project_info.height_under') }}</div>
                            </div>
                        </vwui-card-body>
                    </vwui-card>
                </div>

                <div class="grid__col grid__col--12">

                    <vwui-card>
                        <vwui-card-header>{{ 'PAGE_PROJECT_DETAILS.title_client' | translate }}</vwui-card-header>
                        <vwui-card-body>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.client.client' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.client }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.client.client_type' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ getAnswerValue('client.client_type') }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.client.owner' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.developer }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.client.alt_client' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.clientOther }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.client.acquisition_type' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ getAnswerValue('client.acquisition_type') }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.client.credit_score' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ getAnswerValue('client.credit_score') }}</div>
                            </div>
                        </vwui-card-body>
                    </vwui-card>

                    <div class="grid-spacer"></div>

                    <vwui-card>
                        <vwui-card-header>{{ 'PAGE_PROJECT_DETAILS.title_financial' | translate }}</vwui-card-header>
                        <vwui-card-body>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.financial.contract_scope' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ contractType }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.financial.realisation_form' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ getAnswerValue('financial.realisation_form') }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.financial.criteria' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ getAnswerValue('financial.criteria') }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.project_info.tender_date' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.tenderDate }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.financial.tender_costs' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.tenderCosts | tenderCostsRange }}</div>
                            </div>
                        </vwui-card-body>
                    </vwui-card>

                    <div class="grid-spacer"></div>

                    <vwui-card>
                        <vwui-card-header>{{ 'PAGE_PROJECT_DETAILS.title_planning' | translate }}</vwui-card-header>
                        <vwui-card-body>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.planning.start_date' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ startDate }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.planning.end_date' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ endDate }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.planning.project_duration' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ durationInMonths }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.planning.number_of_phases' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.numberOfPhases }}</div>
                            </div>
                        </vwui-card-body>
                    </vwui-card>

                    <div class="grid-spacer"></div>

                    <vwui-card>
                        <vwui-card-header>{{ 'PAGE_PROJECT_DETAILS.title_team' | translate }}</vwui-card-header>
                        <vwui-card-body>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.team.parties' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.collaborationCompanies }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.team.legal_form' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.legalForm }}</div>
                            </div>
                        </vwui-card-body>
                    </vwui-card>

                    <div class="grid-spacer"></div>

                    <vwui-card>
                        <vwui-card-header>{{ 'PAGE_PROJECT_DETAILS.title_design_team' | translate }}</vwui-card-header>
                        <vwui-card-body>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.design_team.architect' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.architect }}</div>
                            </div>
                            <div class="grid__row">
                                <div class="grid__col grid__col--3 project-details__label">{{ 'PAGE_PROJECT_DETAILS.design_team.constructor' | translate }}</div>
                                <div class="grid__col grid__col--9 project-details__value">{{ project.projectInfo?.buildingConstructor }}</div>
                            </div>
                        </vwui-card-body>
                    </vwui-card>

                    <div class="grid-spacer"></div>

                    <vwui-card>
                        <app-documents [projectId]="project.id"></app-documents>
                    </vwui-card>
                </div>
            </div>
        </div>
    }
</div>
